import { H2, XStack, YStack } from '@bounty/creators-design-system'
import { GetStoreResponseSuccess } from '@bounty/types'
import { useState } from 'react'
import { ProductCard } from '../../../../components/ProductCard'
import { useShopDetailContext } from '../ShopDetailContext'
import { useStorefrontPress } from '../useStorefrontPress'

const FeaturedProduct = ({
  product,
}: {
  product: GetStoreResponseSuccess['data']['featuredProducts'][0]
}) => {
  const [shouldHide, setShouldHide] = useState(false)
  const [, setShopDetailContext] = useShopDetailContext()
  const { onStorefrontPress } = useStorefrontPress()
  return (
    <YStack
      display={shouldHide ? 'none' : 'flex'}
      width="50%"
      mb="$4"
      $gtSm={{ width: '25%' }}
      $gtMd={{ width: '33%' }}
      $gtLg={{ width: '25%' }}
    >
      <XStack>
        <ProductCard
          key={product.id}
          product={product}
          onImageError={() => setShouldHide(true)}
          onPress={() => {
            setShopDetailContext((x) => ({ ...x, productId: product.id }))
            onStorefrontPress({
              redirectUrl: product.redirectUrl,
              // Need to pass in here because this doesn't wait for the setState call above
              productId: product.id,
              pixelParams: {},
            })
          }}
        />
      </XStack>
    </YStack>
  )
}

export const FeaturedProducts = ({
  featuredProducts,
}: {
  featuredProducts: GetStoreResponseSuccess['data']['featuredProducts']
}) => {
  return (
    <YStack width="100%" maxWidth={1300} alignSelf="center">
      <H2 mb="$4" px="$4" size="$xl" $gtMd={{ size: '$2xl' }}>
        Featured Products
      </H2>
      <XStack px="$4" flexWrap="wrap">
        {featuredProducts?.map((product) => {
          return <FeaturedProduct product={product} key={product.id} />
        })}
      </XStack>
    </YStack>
  )
}
